import {
    SET_ORDER,
    GET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS,
    SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS,
    SET_STATE_DROPDOWN,
    GET_STATE_DROPDOWN,
    SET_VENDORDETAILS_NEXT,
    SET_VENDORDETAILSERROR_COUNT,
    GET_VENDOR_DETAILS,
    SET_VENDOR_DETAILS,
    SET_IS_SUBMITTED,
    SET_IS_VENDOR_DETAILS
} from './types';
 
const setOrderDetails = (orderDetails:any) => {
    return {
        type: SET_ORDER,
        orderDetails
    }
}

const getNonStandardEquipmentItemDetails = (catalogRequestBody:{}) => {
    return {  
      type: GET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS,
      catalogRequestBody
    }
  }
  
 const setNonStandardEquipmentItemDetails = (catalogDetails:any,noRecordsMessage:string) => {
    return {
      type: SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS,
      catalogDetails,noRecordsMessage
    }
}

const getStateDropdown = () => {
  return {
    type: GET_STATE_DROPDOWN
  }
}  

const setStateDropdown = (stateDropDown:any) => {
return {
  type:  SET_STATE_DROPDOWN,
  payload: stateDropDown
  }
}

const setVendorDetailsNext = (vendorDetailNext:any) => {
    return {
      type : SET_VENDORDETAILS_NEXT,
      vendorDetailNext
    }
  }

const setVendorDetailsErrorCount = (vendorerrorCount:any) => {
    return {
      type : SET_VENDORDETAILSERROR_COUNT,
      vendorerrorCount
    }
}

const getVendorDetails = (addressBookNo: any) => {
  return {
    type : GET_VENDOR_DETAILS,
    addressBookNo
  }
}

const setVendorDetails = (addressBookNo: any) => {
  return {
    type : SET_VENDOR_DETAILS,
    addressBookNo
  }
}

const setIsVendorDetails = (isVendorDetails: any) => {
  return {
    type : SET_IS_VENDOR_DETAILS,
    isVendorDetails
  }
}

const setIsSubmitted = (isSubmitted: any) =>{
  return{
    type : SET_IS_SUBMITTED,
    isSubmitted
  }
}

export {
    setOrderDetails,
    getNonStandardEquipmentItemDetails,
    setNonStandardEquipmentItemDetails,
    getStateDropdown,
    setStateDropdown,
    setVendorDetailsNext,
    setVendorDetailsErrorCount,
    getVendorDetails,
    setVendorDetails,
    setIsSubmitted,
    setIsVendorDetails
}